export const openWhatsApp = () => {
    const phone = "919025858565";
    const message = "Hello, I would like to know more about SRK Traders.";
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, "_blank");
};